import { dashboardPluginService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    dashboard: {
        login_log: [],
        settlement: [],
        ticket: [],
        user: [],
        transaction: [],
        profit: [],
        chart_data: [],
        balance: 0,
    }
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, dashboard) {
        state.status    = 'success'
        state.dashboard = dashboard
    },
    fail(state) {
        state.status    = 'fail'
        state.dashboard = []
    },
}

const getters = {
    status: state => state.status,
    dashboard: state => state.dashboard
}

const actions = {
    fetchDashboard({commit}) {
        commit('loading')
        return dashboardPluginService.fetchDashboard().then(response => {
            commit('success', response.data.data)
        })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}